import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { dayOfWeekSales, dayOfWeekSalesReport } from '../../../services/tableOrder.service';
import { useTranslation } from 'react-i18next';
import { LOADER_TIMEOUT_TIME, PAYMENT_METHOD_TYPES_TRANSACTION, REPORT_TAX_TYPES, FULLMONTHS, DAYNAMES, CURRENCY_SYMBOL } from '../../../../../utils/Constants';
import { showPrice, getMonthName, getDateWithYearFromString, globalLoader, writeMyExcel, getCompletedMonths } from '../../../../../utils/commonfunction';
import ReactApexChart from 'react-apexcharts';
import { jsPDF } from 'jspdf'; // Import jsPDF
import RecordNotFound from '../../../shared/recordNotFound';
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import html2canvas from 'html2canvas';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import PaymentMethodSelect from '../../../shared/PaymentMethodSelect';

export default function SalesReportStatusByWeek() {


  const { t } = useTranslation();
  const [loader, setLoader] = useState(true);
  const [saleData, setSaleData] = useState(null);
  const [dayByWeekSaleReport, setDayByWeekSaleReport] = useState(null);
  const [dayByWeekSaleTotalReport, setDayByWeekSaleTotalReport] = useState(null);
  const [reportDate, setReportDate] = useState(new Date().getFullYear());
  const [paymentMethod, setPaymentMethod] = useState('');
  const [taxType, setTaxType] = useState(REPORT_TAX_TYPES[0].value);
  const [sortConfig, setSortConfig] = useState({ column: null, order: null });
  const [seriesData, setSeriesData] = useState(null);
  const componentRef = useRef();
  const dropdownRef = useRef(null);
  const theme = useSelector((state) => state.theme.mode);

  const [isOpen, setIsOpen] = useState(false); // Toggle dropdown visibility


  const handleButtonClick = () => {
    setIsOpen(!isOpen); // Toggle dropdown
  };

  const handleOptionClick = (value) => {
    setReportDate(value); // Set selected value
    setIsOpen(false); // Close dropdown
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false); // Close dropdown if clicking outside
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const getTodaySales = (obj) => {
    setLoader(true);
    dayOfWeekSales(obj).then(response => {
      setSaleData(response.data)

      /** Creating series data for graph */
      const weekDays = [t('restaurant.report.graph_byWeek.label_monday'),
      t('restaurant.report.graph_byWeek.label_tuesday'),
      t('restaurant.report.graph_byWeek.label_wednesday'),
      t('restaurant.report.graph_byWeek.label_thursday'),
      t('restaurant.report.graph_byWeek.label_friday'),
      t('restaurant.report.graph_byWeek.label_saturday'),
      t('restaurant.report.graph_byWeek.label_sunday')];
      const series = weekDays.map((day, index) => ({
        name: t(DAYNAMES[index]), // to get translated day name is graph,
        data: response.data.map(month => {
          const dayData = month.data.find(d => d.dayName === day);
          return dayData ? dayData.totalSales : 0;
        })
      }));
      setSeriesData(series);
      console.log("series ====> ", series);
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
    }).catch(error => {
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
      console.log("error ====> ", error);
    });
  }


  /** For sales table information */
  const getTodaySalesReport = (obj) => {
    setLoader(true);
    dayOfWeekSalesReport(obj).then(response => {
      setDayByWeekSaleReport(response?.data?.data || []);
      setDayByWeekSaleTotalReport(response?.data?.totalValues || null)
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
    }).catch(error => {
      setTimeout(() => { setLoader(false); }, LOADER_TIMEOUT_TIME);
      console.log("error ====> ", error);
    });
  }

  useEffect(() => {
    let obj = {
      date: getDateWithYearFromString(reportDate),
      paymentMethod: paymentMethod ? paymentMethod : undefined,
      taxType: taxType ? taxType : undefined
    }
    let obj2 = { ...obj }
    // if (sortConfig) {
    //   obj2 = {
    //     ...obj2,
    //     'sort': JSON.stringify(sortConfig)
    //   }
    // }
    getTodaySales(obj);
    getTodaySalesReport(obj2);
  }, [reportDate, paymentMethod, taxType]);


  const translatedMonths = FULLMONTHS.map((month, index) => t(`${month}`));

  const options = useMemo(() => ({
    theme: {
      mode: theme,
    },
    chart: {
      type: 'area',
      height: 350,
      stacked: true,
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      }
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    colors: ["#f7821b", "#268754", "#2d80fd", "#f89c09", "#bbef4d", "#ad49ea", "#45d8d8",],
    xaxis: {
      categories: translatedMonths
    },
    yaxis: {
      labels: {
        formatter: (value) => `${CURRENCY_SYMBOL} ${value?.toFixed(2)}`, // Format the y-axis labels with the Euro symbol
      },
      opposite: false,
    },
    tooltip: {
      theme: theme,
      y: {
        formatter: function (value) {
          return value ? `(${CURRENCY_SYMBOL} ${value?.toFixed(2)})` : '0.00'; // Adds brackets around the value
        }
      },
      marker: {
        show: true,
        size: 15
      },
    },
    legend: {
      position: 'top'
    },
    grid: {
      show: true,
      borderColor: '#EEE',
      strokeDashArray: 2,
      position: 'back',
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: true
        }
      },
    },

    markers: {
      size: 3,
      colors: ['#fff'],
      strokeColors: ["#f7821b", "#268754", "#2d80fd", "#f89c09", "#bbef4d", "#ad49ea", "#45d8d8",],
      strokeWidth: 1,
      fillOpacity: 1,
      hover: {
        size: undefined,
        sizeOffset: 0
      }
    },
  }), [theme, reportDate]);


  const daysOfWeek = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 0,
  };



  const handleSort = (column) => {
    let newOrder = "asc";

    if (sortConfig.column === column && sortConfig.order === "asc") {
      newOrder = "desc";
    }

    const sortedData = [...dayByWeekSaleReport].sort((a, b) => {
      const dayA = a.data[daysOfWeek[column]];
      const dayB = b.data[daysOfWeek[column]];

      if (newOrder === "asc") {
        return dayA.totalSales - dayB.totalSales;
      } else {
        return dayB.totalSales - dayA.totalSales;
      }
    });

    setSortConfig({ column, order: newOrder });
    setDayByWeekSaleReport(sortedData);

    const sortedTotalData = { ...dayByWeekSaleTotalReport };
    sortedTotalData[column] = sortedData.reduce((acc, curr) => acc + curr.data[daysOfWeek[column]].totalSales, 0);
    setDayByWeekSaleTotalReport(sortedTotalData);
  };


 
  const years = [];
  const currentYear = new Date().getFullYear();
  for (let year = currentYear; year >= 2000; year--) {
    years.push({ label: year.toString(), value: year });
  }


  const handleDownload = () => {
    globalLoader(true);
    downloadPdf();
  }

  const downloadPdf = useReactToPrint({
    onPrintError: (error) => console.log(error),
    content: () => componentRef.current,
    removeAfterPrint: true,
    print: async (printIframe) => {
      const document = printIframe.contentDocument;
      if (document) {
        const html = document.getElementsByTagName("html")[0];
        const canvas = await html2canvas(html, { scale: 2 });
        const pdf = new jsPDF();
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let yOffset = 10;
        let pageHeight = 297;

        if (imgHeight > pageHeight) {
          pdf.addImage(imgData, 'PNG', 2, yOffset, imgWidth, imgHeight);
          pdf.addPage();
          yOffset = 0;
        } else {
          pdf.addImage(imgData, 'PNG', 2, yOffset, imgWidth, imgHeight);
        }
        pdf.save('daily_sales_report.pdf');
        globalLoader(false);
      }
    },
  });



  const handleExportToExcel = () => {
    const EURO = "\u00A3"; // €

    const headers = [
      t("restaurant.report.graph_byWeek.label_month1"),
      t("restaurant.report.graph_byWeek.label_monday"),
      t("restaurant.report.graph_byWeek.label_tuesday"),
      t("restaurant.report.graph_byWeek.label_wednesday"),
      t("restaurant.report.graph_byWeek.label_thursday"),
      t("restaurant.report.graph_byWeek.label_friday"),
      t("restaurant.report.graph_byWeek.label_saturday"),
      t("restaurant.report.graph_byWeek.label_sunday")
    ];

    // Helper function to reorder days from Sunday-Saturday to Monday-Sunday
    const reorderDays = (data) => {
      return [
        data[1], // Monday
        data[2], // Tuesday
        data[3], // Wednesday
        data[4], // Thursday
        data[5], // Friday
        data[6], // Saturday
        data[0]  // Sunday
      ];
    };

    const rows = dayByWeekSaleReport.map((monthData) => {
      const monthName = t(getMonthName(new Date(), monthData.month));

      const dailySales = reorderDays(
        monthData.data.map(
          (dayData) => `${EURO}${showPrice(dayData?.totalSales)}`
        )
      );

      return [monthName, ...dailySales];
    });

    if (dayByWeekSaleTotalReport) {
      const totalRow = [
        t("restaurant.report.graph_byDay.total_label"),
        `${EURO}${showPrice(dayByWeekSaleTotalReport?.Monday)}`,
        `${EURO}${showPrice(dayByWeekSaleTotalReport?.Tuesday)}`,
        `${EURO}${showPrice(dayByWeekSaleTotalReport?.Wednesday)}`,
        `${EURO}${showPrice(dayByWeekSaleTotalReport?.Thursday)}`,
        `${EURO}${showPrice(dayByWeekSaleTotalReport?.Friday)}`,
        `${EURO}${showPrice(dayByWeekSaleTotalReport?.Saturday)}`,
        `${EURO}${showPrice(dayByWeekSaleTotalReport?.Sunday)}`,
      ];

      rows.push(totalRow);
    }

    writeMyExcel([headers, ...rows], "day_by_week_sale_report.xlsx");
  };




  return (
    <main id="main-content">
      <div className="inner-container">
        <div className="d-flex tabs-with-etc justify-content-between align-items-center mb-4">
          <ul className="nav nav-pills gap-3">
            <li className="nav-item">
              <Link className="nav-link " to={"/restaurant/sales"}>
                {t("restaurant.report.byDay")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={"/restaurant/sales/sales-report-status-month"}>
                {t("restaurant.report.byMonth")}
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to={"/restaurant/sales/sales-report-status-week"}>
                {t("restaurant.report.byDayOfWeek")}
              </Link>
            </li>
          </ul>
          <div className="tabls-dowpdown">
            <PaymentMethodSelect name="payment_method_type" value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value)} />
          </div>
        </div>
        <div className="card">
          <div className="card-header border-0">
            <div className="d-flex justify-content-between align-items-center">
              <div style={{ position: "relative", width: "200px" }} ref={dropdownRef}>
                {/* Button to toggle dropdown */}
                <button
                  className="btn btn-date"
                  onClick={handleButtonClick}
                  style={{
                    width: "85%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                  <i className="ti ti-calendar"></i>
                  {reportDate}
                  <i className="ti ti-chevron-down"></i>
                </button>

                {/* Dropdown menu */}
                {isOpen && (
                  <ul
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      width: "100%",
                      maxHeight: "200px", // Set a fixed height
                      overflowY: "auto", // Enable scrolling when content exceeds maxHeight
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      backgroundColor: "#fff",
                      zIndex: 1000,
                      listStyle: "none",
                      margin: 0,
                      padding: 0,
                    }}>
                    {years.map((item, index) => (
                      <li
                        key={index}
                        onClick={() => handleOptionClick(item.value)}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          backgroundColor: reportDate === item.value ? "#f0f0f0" : "transparent",
                        }}
                        onMouseEnter={(e) => (e.target.style.backgroundColor = "#f0f0f0")}
                        onMouseLeave={(e) => (e.target.style.backgroundColor = "transparent")}>
                        {item.value}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* <select className="form-control cp" name='reportDate' value={reportDate} onChange={(e) => setReportDate(e.target.value)} style={{ width: 200 }} >
                <option value="" disabled>{t('placeholder_year')}</option>
                {years.map((item, index) => { return (<option key={index} value={item?.value}>{item?.value}</option>) })}
              </select> */}
              <div className="card-head-group d-flex align-items-center gap-2">
                <select className="form-control cp" name="payment_method_type" value={taxType} onChange={(e) => setTaxType(e.target.value)}>
                  {REPORT_TAX_TYPES.map((item, index) => {
                    return (
                      <option key={index} value={item.value}>
                        {t(item.label)}
                      </option>
                    );
                  })}
                </select>
                <button className="btn btn-black w-100" onClick={handleExportToExcel} disabled={!dayByWeekSaleReport || dayByWeekSaleReport.length === 0}>
                  <i className="ti ti-download"></i> {t("restaurant.report.label_download")}
                </button>

                
              </div>
            </div>
          </div>
          <div className="card-body">{seriesData ? <ReactApexChart options={options} series={seriesData} type="area" height={350} className="dayReport" /> : null}</div>
        </div>
        {loader ? (
          <div className="w-100">
            <Skeleton className="mb-2" height={50} count={5} />
          </div>
        ) : (
          <div className="card mt-4">
            <div className="card-body">
              {dayByWeekSaleReport && dayByWeekSaleReport.length ? (
                <div className="table-responsive" ref={componentRef}>
                  <table className="table table-printable">
                    <thead>
                      <tr>
                        <th>{t("restaurant.report.graph_byWeek.label_month1")}</th>
                        <th>
                          {t("restaurant.report.graph_byWeek.label_monday")}
                        
                        </th>
                        <th>
                          {t("restaurant.report.graph_byWeek.label_tuesday")}
                        
                        </th>
                        <th>
                          {t("restaurant.report.graph_byWeek.label_wednesday")}
                         
                        </th>
                        <th>
                          {t("restaurant.report.graph_byWeek.label_thursday")}
                      
                        </th>
                        <th>
                          {t("restaurant.report.graph_byWeek.label_friday")}
                        
                        </th>
                        <th>
                          {t("restaurant.report.graph_byWeek.label_saturday")}
                          
                        </th>
                        <th>
                          {t("restaurant.report.graph_byWeek.label_sunday")}
                        
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dayByWeekSaleReport && dayByWeekSaleReport.length
                        ? dayByWeekSaleReport.map((monthData, monthIndex) => {
                          // Helper function to reorder days from Sunday-Saturday to Monday-Sunday
                          const reorderDays = (data) => {
                            return [
                              data[1], // Monday
                              data[2], // Tuesday
                              data[3], // Wednesday
                              data[4], // Thursday
                              data[5], // Friday
                              data[6], // Saturday
                              data[0], // Sunday
                            ];
                          };

                          return (
                            <tr key={monthIndex}>
                              <td>{t(getMonthName(new Date(), monthData.month))}</td>
                              {reorderDays(monthData.data).map((dayData, dayIndex) => (
                                <td key={dayIndex}>{CURRENCY_SYMBOL} {showPrice(dayData?.totalSales)}</td>
                              ))}
                            </tr>
                          );
                        })
                        : ""}

                      {dayByWeekSaleTotalReport && (
                        <tr className="total-tr" id="totalSale">
                          <td>{t("restaurant.report.graph_byDay.total_label")}</td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Monday)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Tuesday)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Wednesday)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Thursday)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Friday)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Saturday)}
                            </span>
                          </td>
                          <td>
                            <span className="text-nowrap">
                              {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Sunday)}
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <RecordNotFound heading="restaurant.report.lbl_record_not_found" />
              )}
            </div>
          </div>
        )}

        <div className="card mt-4">
          <div className="card-header">
            <h4 className="m-0">{t("restaurant.report.average_sale_by_week_text")}</h4>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col">
                <div className="p-2 py-3 border d-flex flex-column align-items-center justify-content-center">
                  <span>{t("restaurant.report.graph_byWeek.label_monday")}</span>
                  <h4 className="mt-2">
                    {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Monday / getCompletedMonths())}
                  </h4>
                </div>
              </div>
              <div className="col">
                <div className="p-2 py-3 border d-flex flex-column align-items-center justify-content-center">
                  <span>{t("restaurant.report.graph_byWeek.label_tuesday")}</span>
                  <h4 className="mt-2">
                    {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Tuesday / getCompletedMonths())}
                  </h4>
                </div>
              </div>
              <div className="col">
                <div className="p-2 py-3 border d-flex flex-column align-items-center justify-content-center">
                  <span>{t("restaurant.report.graph_byWeek.label_wednesday")}</span>
                  <h4 className="mt-2">
                    {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Wednesday / getCompletedMonths())}
                  </h4>
                </div>
              </div>
              <div className="col">
                <div className="p-2 py-3 border d-flex flex-column align-items-center justify-content-center">
                  <span>{t("restaurant.report.graph_byWeek.label_thursday")}</span>
                  <h4 className="mt-2">
                    {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Thursday / getCompletedMonths())}
                  </h4>
                </div>
              </div>
              <div className="col">
                <div className="p-2 py-3 border d-flex flex-column align-items-center justify-content-center">
                  <span>{t("restaurant.report.graph_byWeek.label_friday")}</span>
                  <h4 className="mt-2">
                    {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Friday / getCompletedMonths())}
                  </h4>
                </div>
              </div>
              <div className="col">
                <div className="p-2 py-3 border d-flex flex-column align-items-center justify-content-center">
                  <span>{t("restaurant.report.graph_byWeek.label_saturday")}</span>
                  <h4 className="mt-2">
                    {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Saturday / getCompletedMonths())}
                  </h4>
                </div>
              </div>
              <div className="col">
                <div className="p-2 py-3 border d-flex flex-column align-items-center justify-content-center">
                  <span>{t("restaurant.report.graph_byWeek.label_sunday")}</span>
                  <h4 className="mt-2">
                    {t("restaurant.report.graph_byWeek.currency_symbol")} {showPrice(dayByWeekSaleTotalReport?.Sunday / getCompletedMonths())}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}